var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEyeAlt = function SvgIconEyeAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1b1b1b",
    stroke: "#1b1b1b",
    strokeWidth: 0.667,
    clipPath: "url(#icon-eye-alt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6.258c.966 0 1.741.776 1.741 1.742S8.966 9.741 8 9.741A1.737 1.737 0 0 1 6.258 8c0-.966.776-1.742 1.742-1.742Zm0 .459a1.283 1.283 0 1 0-.001 2.565A1.283 1.283 0 0 0 8 6.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.184c1.883 0 3.286.517 4.389 1.28 1.108.769 1.93 1.797 2.634 2.846.273.411.278.943-.004 1.386-.703 1.035-1.524 2.062-2.631 2.831-1.104.768-2.506 1.29-4.388 1.29s-3.284-.522-4.388-1.29C2.503 10.756 1.68 9.727.977 8.69a1.26 1.26 0 0 1 0-1.38C1.68 6.26 2.503 5.233 3.61 4.465 4.714 3.7 6.117 3.184 8 3.184Zm0 .459c-1.41 0-2.61.285-3.695.93-.946.563-1.788 1.388-2.606 2.497l-.35.492-.001.003a.79.79 0 0 0-.058.769l.058.102.002.002c.928 1.361 1.873 2.347 2.955 2.99 1.085.645 2.284.931 3.695.931 1.41 0 2.61-.286 3.695-.931 1.082-.643 2.027-1.629 2.955-2.99l.013-.018.01-.02a.92.92 0 0 0 0-.798l-.01-.021-.013-.019-.35-.492c-.817-1.109-1.659-1.934-2.605-2.497-1.085-.645-2.284-.93-3.695-.93Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-eye-alt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconEyeAlt;